import React from "react"
import { Section } from "@bw/bits"
import PropTypes from "prop-types"
import { Content as ContentModule } from "@bw/modules"
// parse is used to ensure that HTML sent by the CMS is converted to React components
import parse from "html-react-parser"
import { graphql } from "gatsby"

const Content = ({ subtitle, title, suptitle, text, containerSize }) => {
  return (
    <Section
      suptitle={suptitle}
      title={title}
      subtitle={subtitle}
      containerSize={containerSize}
    >
      <ContentModule text={parse(text)} />
    </Section>
  )
}

export default Content

Content.propTypes = {
  text: PropTypes.string,
  containerSize: PropTypes.string,
}

Content.defaultProps = {
  containerSize: "medium",
}

export const query = graphql`
  fragment ContentModuleFragment on ContentModule {
    text
  }
`
